export var CountryCode;
(function (CountryCode) {
    CountryCode["CANADA"] = "CA";
    CountryCode["UNITED_STATES"] = "US";
    CountryCode["SPAIN"] = "ES";
    CountryCode["FRANCE"] = "FR";
    CountryCode["PUERTO_RICO"] = "PR";
    CountryCode["ITALY"] = "IT";
    CountryCode["UNITED_KINGDOM"] = "GB";
    CountryCode["GERMANY"] = "DE";
})(CountryCode || (CountryCode = {}));
//# sourceMappingURL=CountryCode.js.map